module.exports = __webpack_public_path__ + "img/photo-14.4054202c.webp";